import { useTheme } from '@mui/material/styles';
import { BarChart, Bar, Cell, XAxis, YAxis, Tooltip, LabelList, ResponsiveContainer } from 'recharts';
import { chartColorsFor, chartMutedTextColor } from './chartColors';

interface ChartItem {
  name: string;
  code: string;
  qtddoc: string;
}

export const RankEmployesWithMoreMedicalCertificate = ({ data }: { data: ChartItem[] }) => {
  const { palette } = useTheme();
  const isDark = palette.mode === 'dark';

  const barColors = chartColorsFor(isDark);
  const mutedText = chartMutedTextColor(isDark);

  const chartData = data.map((item, index) => {
    const fullLabel = `${item.code} - ${item.name}`;
    return {
      ...item,
      shortName: fullLabel.length > 25 ? fullLabel.slice(0, 25) + '…' : fullLabel,
      qtddoc: Number(item.qtddoc),
      color: barColors[index % barColors.length],
    };
  });

  const maxCount = Math.max(...chartData.map(item => item.qtddoc), 0);
  const controllerHeight = Math.max(chartData.length * 50 + 40, 100);

  return (
    <div style={{ width: '100%'}}>
      <p style={{ color: palette.text.primary, fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
        Os 10 colaboradores com mais documentos
      </p>
      <span style={{ color: mutedText, fontSize: 13, fontWeight: 400 }}>
        Identificar colaboradores com maior quantidade de atestados.
      </span>

    <ResponsiveContainer width="100%" height={controllerHeight}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 20, right: 60, bottom: 10, left: 10 }}
        >
          <XAxis
            type="number"
            domain={[0, maxCount + 1]}
            allowDecimals={false}
            height={50}
            tick={{ fontSize: 12, fill: mutedText }}
            label={{value: 'Documentos', position: 'insideBottomRight', fill: mutedText, fontSize: 16, fontWeight: 500}}
          />
          
          <YAxis
            type="category"
            dataKey="shortName"
            width={160}
            tick={{ fontSize: 13, fill: palette.text.primary, fontWeight: 500 }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            content={({ active, payload, label }) => {
              if (!active || !payload?.length) return null;
              const item = payload[0].payload;
              return (
                <div style={{
                  background: palette.background.paper,
                  border: `1px solid ${palette.divider}`,
                  borderRadius: 6,
                  padding: '8px 12px',
                  fontSize: 13,
                  color: palette.text.primary
                }}>
                  <p style={{ margin: 0, fontWeight: 600 }}>Colaborador: {label}</p>
                  <p style={{ margin: '4px 0 0' }}>Código: {item.code}</p>
                  <p style={{ margin: '4px 0 0' }}>Documentos: {item.qtddoc}</p>
                </div>
              );
            }}
          />
          <Bar
            dataKey="qtddoc"
            name="Documentos"
            radius={[0, 6, 6, 0]}
            barSize={24}
          >
            <LabelList
              dataKey="qtddoc"
              position="right"
              style={{ fontSize: 13, fill: palette.text.primary, fontWeight: 600 }}
            />
            {chartData.map(item => (
              <Cell key={item.code} fill={item.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};